export default __webpack_public_path__ + "static/media/accumulator.97a64a61.png";